import Stack from '@mui/material/Stack';

import { AppButton } from '@/components/atoms';

import { gallery as copy } from '../content';

type Props = {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
};

/**
 * The way to the rest of the archive. Sits below the wall, where what it
 * loads will appear — a "load more" above the grid asks somebody to press a
 * button and then go looking for what it did.
 *
 * It draws nothing once everything is shown, rather than disabling itself: a
 * permanently dead button at the end of every gallery is furniture that only
 * ever says no. The count above the wall is what reports the end.
 */
export function DeliveryLoadMore({ hasMore, loading, onLoadMore }: Props) {
  if (!hasMore) return null;

  return (
    <Stack alignItems="center" sx={{ pt: 10 }}>
      <AppButton
        appVariant="secondary"
        onClick={onLoadMore}
        disabled={loading}
        aria-busy={loading}
      >
        {loading ? 'Loading…' : copy.loadMore}
      </AppButton>
    </Stack>
  );
}
